import React, {useEffect, useState} from "react";
import {Box, IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, Engineering, KeyboardBackspace} from "@mui/icons-material";
import {Blue3} from "../theme/styles";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import AdminWorkGroupTableApplet from "../eoec/applet/impl/Administration/AdminWorkGroupTableApplet";
import AdminWorkGroupEmployeeTableApplet from "../eoec/applet/impl/Administration/AdminWorkGroupEmployeeTableApplet";
import AdminWorkGroupOrganizationTableApplet from "../eoec/applet/impl/Administration/AdminWorkGroupOrganizationTableApplet";
import AdminWorkGroupPositionTableApplet from "../eoec/applet/impl/Administration/AdminWorkGroupPositionTableApplet";
import AdminWorkGroupUserGroupTableApplet from "../eoec/applet/impl/Administration/AdminWorkGroupUserGroupTableApplet";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function AdministrationWorkGroup() {
    const [adminWorkGroupEnterpriseObject] = useState(enterpriseObjectClassFactory("AdminWorkGroup") as EnterpriseObject);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        adminWorkGroupEnterpriseObject.getEnterpriseComponent("AdminWorkGroup")?.setIDOCRequest("v1.AdminWorkGroup-002");
        adminWorkGroupEnterpriseObject.getEnterpriseComponent("AdminWorkGroup")?.setIDOCResponse("v1.AdminWorkGroup-002");

        return () => {}
    }, [adminWorkGroupEnterpriseObject]);

    function renderUserGroup() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "50px", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "9px", marginLeft: "20px", width: "300px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "-2px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                navigate("/administration");
                            }}>
                            <KeyboardBackspace sx={{color: "#1498D8", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Work Groups</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 30px 30px", backgroundColor: "#FFFFFF"}}>
                    <AdminWorkGroupTableApplet enterpriseComponent={adminWorkGroupEnterpriseObject?.getEnterpriseComponent("AdminWorkGroup")}/>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 30px 30px", backgroundColor: "#FFFFFF"}}>
                    <AdminWorkGroupEmployeeTableApplet enterpriseComponent={adminWorkGroupEnterpriseObject?.getEnterpriseComponent("AdminWorkGroupEmployee")}/>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 30px 30px", backgroundColor: "#FFFFFF"}}>
                    <AdminWorkGroupOrganizationTableApplet enterpriseComponent={adminWorkGroupEnterpriseObject?.getEnterpriseComponent("AdminWorkGroupOrganization")}/>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 30px 30px", backgroundColor: "#FFFFFF"}}>
                    <AdminWorkGroupPositionTableApplet enterpriseComponent={adminWorkGroupEnterpriseObject?.getEnterpriseComponent("AdminWorkGroupPosition")}/>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 20px 30px 30px", backgroundColor: "#FFFFFF"}}>
                    <AdminWorkGroupUserGroupTableApplet enterpriseComponent={adminWorkGroupEnterpriseObject?.getEnterpriseComponent("AdminWorkGroupUserGroup")}/>
                </div>
            </>
        );
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Administration</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <Box sx={{p: 2, bgcolor: "background.paper", width: "450px", height: "260px"}}>
                                <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between"}}>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/roles");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Roles</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Positions</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}} onClick={() => {
                                                setMenu(null)
                                                navigate("/administration/organizations");
                                            }}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Organizations</Typography>
                                        </div>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "row", alignContent: "space-between", marginTop: "20px"}}>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>User Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                            <IconButton className={css_buttons.blueIconButton} style={{height: "75px"}}>
                                                <Engineering sx={{color: Blue3, width: "150px", height: "75px"}}/>
                                            </IconButton>
                                            <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Work Groups</Typography>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto", width: "33%"}}>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderUserGroup()}
        </div>
    );
}